import React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { CorrectiveActionHistory } from "../../constants/interfaces";
import { Typography } from "@material-ui/core";
import formatDate, { parseDate } from "../../utils/formatDate";
import classNames from "../../utils/classNames";
import { compareDesc } from "date-fns";

type Props = {
  classes: any;
  history: CorrectiveActionHistory[] | undefined;
};

type State = {
  selectedResponse: CorrectiveActionHistory | null;
};

const styles = (theme: Theme) =>
  createStyles({
    date: {
      color: theme.palette.primary.light,
      cursor: "pointer",
      marginBottom: theme.spacing(1)
    },
    historyList: {
      listStyle: "none",
      maxHeight: "150px",
      minWidth: "100px",
      overflowY: "auto",
      padding: 0
    },
    root: {
      display: "flex",
      marginLeft: theme.spacing(2)
    },
    selectedDate: {
      color: theme.palette.primary.dark
    },
    selectedReponse: {
      marginTop: theme.spacing(2)
    },
    selectedReponseHeader: {
      marginBottom: theme.spacing(1)
    }
  });

class HistoryTab extends React.Component<Props, State> {
  sortedDates: CorrectiveActionHistory[];

  constructor(props: Props) {
    super(props);
    this.sortedDates = props.history
      ? props.history.sort((a, b) =>
          compareDesc(
            parseDate(a.responseReceivedDate),
            parseDate(b.responseReceivedDate)
          )
        )
      : [];
    this.state = {
      selectedResponse: this.sortedDates[0]
    };
    this.onSelectResponse = this.onSelectResponse.bind(this);
  }

  onSelectResponse(response: CorrectiveActionHistory) {
    this.setState({
      selectedResponse: response
    });
  }

  render() {
    const { classes } = this.props;
    const { selectedResponse } = this.state;
    return (
      <div className={classes.root}>
        <ul className={classes.historyList}>
          {this.sortedDates.map((response: CorrectiveActionHistory, index) => {
            const selected = selectedResponse === response;
            return (
              <li key={index}>
                <Typography
                  className={classNames(
                    classes.date,
                    selected ? classes.selectedDate : null
                  )}
                  onClick={() => this.onSelectResponse(response)}
                >
                  {formatDate.condensed(response.responseReceivedDate)}
                </Typography>
              </li>
            );
          })}
        </ul>
        {selectedResponse && (
          <div className={classes.selectedReponse}>
            <Typography className={classes.selectedReponseHeader}>
              Submitted by{" "}
              <strong>{selectedResponse.correctiveActionAuthor}</strong>,{" "}
              {formatDate.fullText(selectedResponse.responseReceivedDate)}
            </Typography>
            <Typography>{selectedResponse.correctiveActionResponse}</Typography>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(HistoryTab);
